(function() {
    'use strict';

    angular.module('app').factory('DistributionService', DistributionService);

    DistributionService.$inject = ['distribution'];

    function DistributionService(data) {
        return {
            distribution: distribution,
            code: code,
            is: is,
            changable: changable,
            change: change,
            image: image,
            document: document,
            react: react,
            defaults: defaults,
        };

        function changable() {
            return data.changable;
        }

        function react() {
            return data.react;
        }

        function defaults() {
            return data.defaults;
        }

        function change(code) {
            data.code = code;
            var $html = angular.element('html');

            $html.data('distribution', code);

            $html.removeClass('app-siehs app-ww app-flotico');
            $html.addClass('app-' + code);
        }

        function distribution() {
            return data;
        }

        function is(code) {
            return data.code === code;
        }

        function code() {
            return distribution().code;
        }

        function image(path) {
            return '/img/' + distribution().code + path;
        }

        function document(path) {
            return '/documents/' + distribution().code + path;
        }
    }
})();
